"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.IconButtonStyled = styled_components_1.default.button `
  background: ${({ isActive, isInverted, theme }) => {
    if (!isActive) {
        return 'transparent';
    }
    return isInverted ? theme.backgroundActiveInverted : theme.backgroundActive;
}};
  border: 2px solid transparent;
  border-radius: 6px;
  display: flex;
  outline: none;
  padding: 0;
  transition: all 200ms ease-in;
  ${props => !props['aria-disabled'] &&
    `
    cursor: pointer;
    &:hover {
      background: ${props.isInverted
        ? props.theme.backgroundHoverInverted
        : props.theme.backgroundHover};
    }
    &:active {
      background: ${props.isInverted
        ? props.theme.backgroundActiveInverted
        : props.theme.backgroundActive};
    }
  `}
  &:focus-visible {
    border-color: ${({ theme }) => theme.borderFocus};
  }
`;
